export default "__VITE_ASSET__3cba5c50__"